export function initEmailJump() {
  const emailJumpButton = document.querySelector<HTMLButtonElement>("[data-email-jump]");
  const paymentForm = document.getElementById("payment-form");
  const visibleEmailInput = document.querySelector<HTMLInputElement>('input[type="email"][name="email"]');

  if (!emailJumpButton || !paymentForm || !visibleEmailInput) return;

  emailJumpButton.addEventListener("click", function (e) {
    e.preventDefault();
    paymentForm.scrollIntoView({ behavior: "smooth" });
    setTimeout(function () {
      visibleEmailInput.focus();
    }, 250);
  });
}